const userInfo = {
    
  state: {
    userInfo: {
      // 初始化一个userInfo对象，结构与您commit的数据一致
      userId: "",
      name: "",
      email: "",
      roles: [], // 初始化为空数组
    },
  },
  // 2. 定义变更方法 (Mutations)
  mutations: {
    // 定义 SET_USER_INFO mutation
    // state 是当前的state对象
    // payload 是调用commit时传入的额外参数，即您要设置的新用户信息对象
    SET_USER_INFO(state, payload) {
      // 使用 Vue.set 或对象展开运算符确保响应性，特别是当需要添加新属性时
      // 此处直接赋值，因为userInfo对象已预先定义好所有属性
      state.userInfo = {
        userId: payload.userId,
        name: payload.name,
        email: payload.email,
        roles: payload.roles || [], // 确保roles始终是数组
          };       

      // 或者使用 Object.assign 确保响应性
      // Object.assign(state.userInfo, payload);
    },
    // 一个可选的清除用户信息的mutation
    CLEAR_USER_INFO(state) {
      state.userInfo = {
        userId: "",
        name: "",
        email: "",
        roles: [],
      };
    },
    },
  
  // 3. 定义动作 (Actions) - 用于处理异步操作或复杂的业务逻辑
  actions: {
    // 一个常见的action：异步获取用户信息并提交mutation
    async fetchUserInfo({ commit }, userId) {
      try {
        // 模拟异步API请求
        // const response = await api.getUserInfo(userId);
        // 假设返回的数据结构类似 { userId: '123', name: '张三', emails: ['zhangsan@example.com'], roles: ['admin'] }
        const userInfo = await yourApiCallToGetUser(userId); 
        
        // 提交 SET_USER_INFO mutation 来更新state
        commit('SET_USER_INFO', {
          userId: userInfo.userId,
          name: userInfo.name,
          email: userInfo.emails?.[0] || '', // 处理email逻辑
          roles: userInfo.roles || []
        });
      } catch (error) {
        console.error('获取用户信息失败:', error);
        // 可以在这里提交另一个mutation来更新错误状态
      }
    },
    // 一个简单的action，直接设置用户信息（您代码中的方式）
    setUserInfo({ commit }, userInfoPayload) {
      commit('SET_USER_INFO', userInfoPayload);
    },
    // 退出登录的action
    logout({ commit }) {
      commit('CLEAR_USER_INFO');
      // 还可以进行其他清理工作，如清除token等
    }
  },
//   // 4. 定义获取器 (Getters) - 类似于计算属性，用于从state中派生出一些状态
//   getters: {
//     // 获取完整的用户信息
//     currentUser: (state) => state.userInfo,
//     // 用户是否已登录（根据userId或name判断）
//     isLoggedIn: (state) => !!(state.userInfo.userId || state.userInfo.name),
//     // 用户角色列表
//     userRoles: (state) => state.userInfo.roles,
//     // 检查用户是否具有某个特定角色
//     hasRole: (state) => (roleName) => state.userInfo.roles.includes(roleName)
//   }
};
export default userInfo;
